import { tokens } from '../forms/tokens';

export interface ShownLink {
  /** Whom the invitation is for: the address it was sent to. */
  readonly who: string;
  readonly link: string;
}

/**
 * The links of the invitations a super admin just created. The server sends them only where a rehearsal
 * runs (staging, a developer's machine): the e-mail there goes to an address nobody reads, so without the
 * link a tester could never open the invitation. In production the list is always empty and nothing shows.
 */
export default function InvitationLinks({ links }: Readonly<{ links: readonly ShownLink[] }>): JSX.Element | null {
  if (links.length === 0) return null;
  return (
    <div
      className="rounded-2xl p-5 mb-6"
      style={{ background: tokens.infoBg, color: tokens.infoText, border: `1px solid ${tokens.infoBorder}` }}
    >
      <h3 className="font-semibold mb-1">Invitation links (rehearsal only)</h3>
      <p className="text-sm mb-3">
        The e-mail goes to an address nobody reads here, so open the invitation from its link. Each link works once
        and is a secret: do not share it.
      </p>
      <ul className="text-sm space-y-2 break-all">
        {links.map((item) => (
          <li key={item.link}>
            <span translate="no">{item.who}</span>
            {' — '}
            <a href={item.link} className="underline" translate="no">{item.link}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
